import {combineReducers} from 'redux';
import search from '../common/search-reducer';
import spots from '../common/spots-reducer';

export default combineReducers({
    search,
    spots
});



// WEBPACK FOOTER //
// ./widget/src/js/reducers/index.js